"use client";
import { CircleAlertIcon } from "lucide-react";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {

  return (
    <Sonner
      className="toaster group"
      {...props}
      style={        {
          "--width": "var(--toast-width)",
        } as React.CSSProperties
}
      position="bottom-center"
      richColors={true}
      icons={{
        success: <CircleAlertIcon className="size-4"/>
      }}
      toastOptions={{
        classNames: {
          toast: "rounded-lg flex item-start shadow-lg border p-4",
          title: "font-semibold",
          description: "opacity-85",
        },
      }}
    />
  );
};

export { Toaster };
